import { render, staticRenderFns } from "./shmanage.vue?vue&type=template&id=3c38ff58&scoped=true"
import script from "./shmanage.vue?vue&type=script&lang=js"
export * from "./shmanage.vue?vue&type=script&lang=js"
import style0 from "./shmanage.vue?vue&type=style&index=0&id=3c38ff58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38ff58",
  null
  
)

export default component.exports